<template>
   <div class="map-overview">
      <Trajectory v-if="getTrajectory"></Trajectory>
      <filters :objectTypes="objectTypes" :trajects="trajects" @set-filter="setFilter"></filters>
      <span v-if="!isLoading">
        <map-details :mapCenter="getMapCenter" :zoom="9" :disableElement="isLoading"></map-details>
<!-- <legends></legends> -->
      </span>
      <span v-else>
        <map-details :mapCenter="[51.9964998, 4.2913794]" :zoom="9"></map-details>
        <span class="loader-section"><Loader></Loader></span>
      </span>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import mapDetails from '../components/mapDetails'
import Trajectory from '@/pages/Trajectory'
import Filters from '../components/Filters'
// import legends from '../components/legends'
import Loader from '../components/Loader'

export default {
  computed: {
    ...mapState('projects', ['filters', 'isLoading']),
    ...mapGetters('projects', ['objectTypes', 'trajects', 'getMapCenter']),
    ...mapGetters(['getTrajectory'])
  },
  components: {
    mapDetails,
    Filters,
    Trajectory,
    Loader
  },
  methods: {
    setFilter (filter) {
      let query = Object.assign({}, filter)
      this.$store.dispatch('projects/setFilter', query)
    }
  }
}
</script>
<style lang="sass">
@import '../sass/variables.sass'
.map-overview, .map-overview > span
    flex: 1
    display: flex
    flex-direction: column
.map-overview
    position: relative
</style>



// WEBPACK FOOTER //
// src/pages/Overview.vue